import { useQuery } from "@apollo/client";
import { useAuth0 } from "@auth0/auth0-react";
import { constantsData, urlsData } from "data";
import { getTerritoryQuery } from "graph";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { openAlert } from "redux/actions";
import { displayErrorHandler } from "utils";

const useGetTerritory = (id) => {
    const { isAuthenticated } = useAuth0();

    const { t } = useTranslation();

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const {
        data,
        error,
        loading,
    } = useQuery(
        getTerritoryQuery,
        {
            onCompleted: ({ territory }) => {
                if (!territory) navigate(urlsData.routes.notFound);
            },
            skip: !isAuthenticated,
            variables: {
                where: { id },
            },
        },
    );

    useEffect(
        () => {
            if (error?.message === constantsData.failedToFetch && !loading) {
                displayErrorHandler(
                    t("messages.networkFailure"),
                    dispatch,
                    openAlert,
                );
            }
        },
        [error, data], // eslint-disable-line
    );

    return {
        data: data?.territory,
        loading,
    };
};

export default useGetTerritory;
